import Class from './c-indicator';
import './c-indicator@';
import './c-indicator.scss';

export default Class;